import useStore from './useStore';

const useLocale = () => useStore().store.locale;

export default useLocale;
